import { BarcodeIcon } from "@/components/icons/barcode-icon";
import { CameraIcon } from "@/components/icons/camera-icon";
import { LinkSimpleIcon } from "@/components/icons/link-simple-icon";
import { PencilSimpleIcon } from "@/components/icons/pencil-simple-icon";
import { SearchIcon } from "@/components/icons/search-icon";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface AddFoodOption {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}

export const addFoodOptions: AddFoodOption[] = [
  {
    icon: SearchIcon,
    label: "Search",
  },
  {
    icon: LinkSimpleIcon,
    label: "Add from a link",
  },
  {
    icon: CameraIcon,
    label: "Take a photo of a recipe",
  },
  {
    icon: PencilSimpleIcon,
    label: "Add manually",
  },
  {
    icon: BarcodeIcon,
    label: "Scan a barcode",
  },
];

interface AddFoodOptionsListProps {
  className?: string;
}

/**
 * Displays the list of available options for adding food
 * Used in onboarding and meal plan features
 */
export const AddFoodOptionsList = memo(function AddFoodOptionsList({
  className,
}: AddFoodOptionsListProps) {
  return (
    <div className={cn("space-y-2", className)}>
      {addFoodOptions.map((option, index) => {
        const Icon = option.icon;
        return (
          <div key={index} className="flex items-center gap-2">
            <Icon className="h-6 w-6" />
            <p className={cn(textVariants.bodySingleLine, "text-black")}>{option.label}</p>
          </div>
        );
      })}
    </div>
  );
});
